import React, { useState } from 'react';
import RemotePro from "../images/remotepro.jpg"
import ElectronicSignature from "../images/electronic-signature.png"
import FaceMatch from '../images/biometric.png'
import Statkraft from "../images/statkraft.jpg" 
import SwissArquitects from "../images/swiss-architects.jpg"
import Bimedis from "../images/bimedis.jpg"
import MySwitzerland from "../images/myswitzerland.jpg"
import RadissonHotels from "../images/radissonhotels.png"
import SwissHeidi from "../images/swissheidi.jpg"
import WidderHotel from "../images/widderhotel.jpg"
import Pharmacielo from "../images/pharmacielo.jpg"

import { 
  GlobeAltIcon, 
  ServerIcon, 
  ShoppingBagIcon,
  BuildingOfficeIcon,
  CreditCardIcon,
  CloudArrowUpIcon,
  BookOpenIcon,
  FilmIcon,
  CheckCircleIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const Projects: React.FC = () => {
  const [filter, setFilter] = useState('all');
  const [selectedProject, setSelectedProject] = useState<typeof projects[0] | null>(null);

  const projects = [
    {
      title: "RemotePro",
      category: "web",
      description: "It is a job board platform focused exclusively on remote work opportunities.",
      technologies: ["Laravel", "Vue 3", "Forge", "Mysql", "Algolia", "OpenAI", "DeepSeek", "AWS"],
      icon: CheckCircleIcon,
      highlights: ["10x cost reduction", "80% faster approval", "Automated workflows"],
      image: RemotePro,      
      features: [
        "Built the entire website from scratch", 
        "Built web crawlers to get information from differents websites",                 
        "Built using Laravel, Mysql, Vue, Tailwind and Octane/Swoole", 
        "Set up hosting using Laravel Forge", 
        "Set up and configured Stripe integration for payment processing", 
        "Performed testing on APIs and various application components using PEST/TDD", 
        "I built an AI-powered feature to automatically approve listings", 
        "Migrated the completions API from OpenAI to DeepSeek, and that brought the implementation costs down by 10x", 
        "Migrated Alpinejs to Vue 3", 
        "Integrated Algolia through Laravel Scout to enhance search performance and user experience", 
        ],
        link: "https://remotepro.co/"
    },
    {
      title: "Government and Digital Signature APIs",
      category: "saas",
      description: "Led, prototyped, and launched APIs for government and digital signature chatbots with high security requirements.",
      technologies: ["Laravel", "AWS", "PostgreSQL", "Redis", "Saloon", "APIs", "Webhooks", "Queues", "Docker"],
      icon: BuildingOfficeIcon,
      highlights: ["Government compliant", "High security", "Scalable architecture"],
      image: ElectronicSignature,      
      features: [
        "Built with the Saloon library to improve architecture and testability",
        "Compatible with the Webhook arquitecture"        
      ],
      link: "https://jelou.ai/en"
    },
    {
      title: "Biometric Recognition APIs",
      category: "saas", 
      description: "Designed and developed APIs for biometric chatbots including facial and face match recognition.",
      technologies: ["Laravel", "AWS", "PostgreSQL", "Redis", "Saloon", "APIs", "Webhooks", "Queues", "Docker"],
      icon: CheckCircleIcon,
      highlights: ["Face recognition", "Real-time processing", "High accuracy"],
      image: FaceMatch,      
      features: [
        "Real-time facial recognition", 
        "Liveness detection",
        "Built with the Saloon library to improve architecture and testability", 
        "Compatible with the Webhook arquitecture"
      ],
      link: "https://jelou.ai/en"
    },
    {
      title: "Multi-Provider Payment Gateway",
      category: "saas",
      description: "Engineered a payment gateway microservice supporting multiple payment gateways.",
      technologies: ["Laravel", "Nova", "Vue", "Inertia.js", "AWS", "Stripe", "Prometeo", "Epayco", "Niubiz"],
      icon: CreditCardIcon,
      highlights: ["Multiple providers", "Unified API"],
      image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=400&fit=crop",      
      features: [
        "Multi-provider abstraction", 
        "Automatic failover", 
        "Intelligent routing", 
        "Advanced fraud detection"
      ],
      link: "https://jelou.ai/en"     
    },
    {
      title: "Renewable Energy Management Platform",
      category: "web",
      description: "Statkraft is a platform for renewable energy project and investment management with real-time updates.",
      technologies: ["Laravel", "PostgreSQL", "Redis", "ElasticSearch", "WebSockets", "Vue"],
      icon: CloudArrowUpIcon,
      highlights: ["Real-time updates", "Investment tracking"],
      image: Statkraft,      
      features: [
        "Real-time energy monitoring", 
        "Investment portfolio tracking",                         
        "Automated reporting"
      ],
      link: "https://jelou.ai/en"
    },
    {
      title: "Architecture Job Platform",
      category: "web",
      description: "Swiss Architects is a platform for architects and building professionals to manage job ads and resumes.",
      technologies: ["Laravel", "MySQL", "MongoDB", "RabbitMQ", "Livewire", "Tailwind"],
      icon: BuildingOfficeIcon,
      highlights: ["Dual accounts", "Resume builder", "Job matching"],
      image: SwissArquitects,      
      features: [
        "Industry-specific job categories", 
        "Job matching", 
        "Portfolio showcase",        
        "Professional networking"
      ],
      link: "https://www.swiss-architects.com/"   
    },
    {
      title: "Medical E-Commerce Platform",
      category: "ecommerce",
      description: "Bimedis is an e-commerce website for medical devices",
      technologies: ["Laravel", "React", "Tailwind", "Docker"],
      icon: ShoppingBagIcon,
      highlights: [
         "SEO optimized", 
         "Medical compliance"
      ],
      image: Bimedis,
      features: [    
        "Medical device categorization",         
        "Supplier integration", 
        "Advanced search and filtering"
      ],
      link: "http://bimedis.com/"
    },
    {
      title: "Switzerland Attractions Booking",
      category: "web",
      description: "Designed and developed a website for buying attraction passes in Switzerland.",
      technologies: ["Laravel", "Vue", "Tailwind"],
      icon: GlobeAltIcon,
      highlights: ["Tourism platform", "Multi-language", "Payment Integration"],
      image: MySwitzerland,
      features: [
        "Multi-language support", 
        "Dynamic pricing engine", 
        "Mobile-optimized passes", 
        "Attraction analytics dashboard",
         "Partner API integration"
      ],
      link: "https://www.myswitzerland.com/en/"    
    },
    {
      title: "Restaurant Reservation System",
      category: "web",
      description: "Radisson Hotels itself is a large international hotel chain with properties around the world",
      technologies: ["PHP Custom CMS", "Bootstrap", "MySQL", "Vue"],
      icon: BookOpenIcon,
      highlights: [
        "Real-time booking", 
        "Admin dashboard", 
        "Customer management"
      ],
      image: RadissonHotels,
      features: [     
        "Built website from scratch using a Custom CMS",
        "Built Vue Components", 
        "Built Reservation system", 
        "Deployed to AWS"
      ],
      link: "https://www.radissonhotels.com/en-us/"
    },
    {
      title: "Hotel Reservation Platform",
      category: "web",
      description: "Swiss Heidi Hotel is a comfortable, mid-range hotel located in Maienfeld, in the Graubünden region of Switzerland",
      technologies: ["Wordpress", "React", "Bootstrap"],
      icon: BookOpenIcon,
      highlights: [
        "Real-time booking", 
        "Admin dashboard", 
        "Customer management"
      ],
      image: SwissHeidi,
      features: [     
        "Converted PSD template into Wordpress/Bootstrap theme", 
        "Built backend modules for managing reservations", 
        "Built custom frontend component for creating reservations using React",
        "Deployed to DigitalOcean"
      ],
      link: "https://swissheidihotel.ch/en/"
    },
    {
      title: "Custom CMS implementation",
      category: "web",
      description: "Widder Hotel is a 5-star superior boutique luxury hotel located in the historic Old Town (Altstadt) of Zurich, Switzerland",
      technologies: ["PHP", "Custom CMS", "Bootstrap"],
      icon: BookOpenIcon,
      highlights: [
        "Real-time booking", 
        "Admin dashboard"       
      ],
      image: WidderHotel,
      features: [     
        "Built website from scratch using a custom CMS and Bootstrap", 
        "Connected to booking platform"        
      ],
      link: "https://www.widderhotel.com/en/"   
    },
    {
      title: "Pharmacielo",
      category: "web",
      description: "PharmaCielo is a global company headquartered in Canada",
      technologies: ["PHP", "Wordpress", "Bootstrap"],
      icon: BookOpenIcon,
      highlights: [
        "Bootstrap", 
        "Wordpress"       
      ],
      image: Pharmacielo,
      features: [     
        "Built website from scratch using Wordpress",
        "PSD to HTML/Bootstrap"      
      ],
      link: "https://www.pharmacielo.com/"  
    },
     
  ];

  const categories = [
    { id: 'all', name: 'All Projects' },
    { id: 'web', name: 'Web Platforms' },
    { id: 'ecommerce', name: 'E-Commerce' },    
    { id: 'saas', name: 'Saas' }
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <section id="projects" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Featured <span className="gradient-text">Projects</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A selection of innovative solutions and applications I've built for various industries
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setFilter(category.id)}
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                filter === category.id
                  ? 'bg-gradient-to-r from-primary-600 to-blue-600 text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden card-shadow hover:scale-105 transition-all duration-300 h-full flex flex-col"
            >
              <div className="relative h-48 bg-gradient-to-br from-primary-400 to-blue-500">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover opacity-80"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <project.icon className="w-8 h-8 text-white" />
                </div>
              </div>
              
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{project.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed flex-grow">{project.description}</p>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.technologies.map((tech) => (
                    <span 
                      key={tech}
                      className="px-2 py-1 bg-primary-50 text-primary-700 rounded-md text-xs font-medium"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                
                <div className="space-y-2 mb-auto">
                  {project.highlights.map((highlight, idx) => (
                    <div key={idx} className="flex items-center text-sm text-gray-700">
                      <CheckCircleIcon className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" />
                      {highlight}
                    </div>
                  ))}
                </div>
                
                <button
                  onClick={() => setSelectedProject(project)}
                  className="mt-4 w-full bg-gradient-to-r from-primary-600 to-blue-600 text-white py-2 px-4 rounded-lg font-medium hover:from-primary-700 hover:to-blue-700 transition-all duration-300 flex items-center justify-center"
                >
                  See More
                  <CheckCircleIcon className="w-4 h-4 ml-2" />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">Additional Expertise</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl p-6 card-shadow">
              <ServerIcon className="w-12 h-12 text-primary-600 mb-4 mx-auto" />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">API Development</h4>
              <p className="text-gray-600 text-sm">RESTful APIs, microservices, Twilio integration, speech-to-text</p>
            </div>
            <div className="bg-white rounded-xl p-6 card-shadow">
              <CloudArrowUpIcon className="w-12 h-12 text-green-600 mb-4 mx-auto" />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Cloud & DevOps</h4>
              <p className="text-gray-600 text-sm">AWS deployment, Docker containerization, CI/CD pipelines, monitoring</p>
            </div>
            <div className="bg-white rounded-xl p-6 card-shadow">
              <FilmIcon className="w-12 h-12 text-purple-600 mb-4 mx-auto" />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Performance & Legacy</h4>
              <p className="text-gray-600 text-sm">250% performance gains, legacy modernization, PSD to React/Vue conversion</p>
            </div>
          </div>
        </div>
      </div>

      {selectedProject && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <div className="relative h-64 bg-gradient-to-br from-primary-400 to-blue-500">
                <img 
                  src={selectedProject.image} 
                  alt={selectedProject.title}
                  className="w-full h-full object-cover opacity-80"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <button
                  onClick={() => setSelectedProject(null)}
                  className="absolute top-4 right-4 bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full transition-colors"
                >
                  <XMarkIcon className="w-6 h-6" />
                </button>
                <div className="absolute bottom-4 left-4">
                  <selectedProject.icon className="w-12 h-12 text-white" />
                </div>
              </div>
              
              <div className="p-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">{selectedProject.title}</h2>
                
                <div className="mb-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">Project Overview</h3>
                  <p className="text-gray-600 leading-relaxed">{selectedProject.description}</p>
                </div>             
                
                <div className="mb-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">Challenges Overcome</h3>
                  <div className="space-y-2">
                    {selectedProject.features?.map((feature, idx) => (
                      <div key={idx} className="flex items-start">
                        <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-6 flex justify-center">
                  <a target='_blank' rel="nofollow noreferrer" href={selectedProject.link} className="px-6 py-2 rounded-full font-medium transition-all duration-300 bg-gradient-to-r from-primary-600 to-blue-600 text-white">Project</a>               
                </div>

                <div className="flex gap-4">
                  <button
                    onClick={() => setSelectedProject(null)}
                    className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 py-3 px-6 rounded-lg font-medium transition-colors"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;